import { nameOfFactory } from "@libs/utils/name-of.utils.ts";
import { EncounterFormValues } from "@shared-types/clinical/encounter-values.interface.ts";

import { EncounterFormResponsiveHeader } from "./EncounterFormResponsiveHeader.tsx";

export const nameOf = nameOfFactory<EncounterFormValues>();
export const EncounterFormHeader: React.FC = () => {
  return <EncounterFormResponsiveHeader />;
};
